module.exports = __webpack_public_path__ + "static/media/memberList.01c6bac1.svg";